import React from 'react';
import {
  MarketplaceProduct,
  formatMarketplaceProductPricing,
  workspaceDiyStartClass,
  workspaceExploreClass,
} from '../utils/marketplaceProducts';

interface CommercialProductListProps {
  products: MarketplaceProduct[];
  busy?: boolean;
  onExplore: (product: MarketplaceProduct) => void;
  onStart: (product: MarketplaceProduct) => void;
}

const CommercialProductList: React.FC<CommercialProductListProps> = ({
  products,
  busy = false,
  onExplore,
  onStart,
}) => {
  if (products.length === 0) {
    return (
      <p className="text-sm text-gray-500">
        No marketplace products are configured for this category yet.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      {products.map((product) => {
        const isDiy = product.service_type === 'DIY';
        return (
          <div
            key={product.id}
            className="rounded-xl border border-[#E0DEE8] bg-white p-5 flex items-center justify-between gap-5"
          >
            <div className="min-w-0 flex-1">
              <h3 className="text-base font-bold text-[#655FA8]">{product.name}</h3>
              <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                {product.short_description}
              </p>
              <p className="mt-4 text-sm font-bold text-[#655FA8]">
                {formatMarketplaceProductPricing(product)}
              </p>
            </div>
            <button
              type="button"
              className={isDiy ? workspaceDiyStartClass : workspaceExploreClass}
              onClick={() => (isDiy ? onStart(product) : onExplore(product))}
              disabled={busy}
            >
              {isDiy ? 'Start' : 'Explore'}
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default CommercialProductList;
